import axios from 'axios';
import AppConfig from "../../../../AppConfig";

let URL = AppConfig.HOST_API()+'rozklad/';

export default {

    getRozklad() {
        return axios({
            method: 'get',
            url: URL + '?page=0&size=9999',
        });
    },

    getSzukajRozklad(params) {
        return axios({
            method: 'get',
            url: URL + 'szukaj?page=0&size=9999&'+params,
        });
    },

    getSzukajRozkladPoStronie(page,size,params){
        return axios({
            method: 'get',
            url: URL + 'szukaj?page='+page+'&size='+size+'&'+params+'&sort=godzOdj',
        });
    },

    getZrobRozklad(data,trasa_id,godzina) {
        return axios({
            method: 'get',
            url: URL + 'pZrobRozkladJazdyTs?data='+data+'&idTr='+trasa_id+'&godz1p='+godzina,
        });
    },

    getZrobRozkladDlaJednejTrasy(trasa_id, data_od, data_do, godzina){
        return axios({
            method: 'get',
            url: URL+'pZrobRozklJazdyTr?dataOd='+data_od+'&dataDo='+data_do+'&idTr='+trasa_id+'&godz1p='+godzina,
        });
    },

    getZrobRozkladDlaWszystkichTras() {
        return axios({
            method: 'get',
            url: URL + 'pZrobRozkladJazdyTsTot',
        });
    },

    getSzukajRozkladPierwszePrzystanki(page,size,params){
        return axios({
            method: 'get',
            url: AppConfig.HOST_API()+'vRozklJazdy1P/szukaj' + '?page='+page+'&size='+size+'&'+params,
        });
    },

    dodajGodzineRozkladPierwszePrzystanki(data){
        return axios({
            method: 'post',
            url: AppConfig.HOST_API()+'vRozklJazdy1P/',
            data: JSON.stringify(data),
        })
    },

    edytujGodzineRozkladPierwszePrzystanki(id,data){
        return axios(
            {
                url: AppConfig.HOST_API()+'vRozklJazdy1P/' + id,
                method: 'put',
                data: JSON.stringify(data),
            }
        )
    },

    usunGodzineRozkladPierwszePrzystanki(id){
        return axios({
                url: AppConfig.HOST_API()+'vRozklJazdy1P/' + id,
                method: 'delete',
            }
        )
    }

}


// WEBPACK FOOTER //
// ./src/modules/konfiguracja/rozkladConfig/rozklad/RozkladService.js